import { FormControl, FormField, FormItem, FormLabel } from "@/components/ui/form"
import { Input } from "@/components/ui/input"
import { useTranslations } from "next-intl"

interface ContactNameFieldProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: any
  label?: string | null
  required?: boolean
}

const ContactNameField = ({ form, label, required = true }: ContactNameFieldProps) => {
  const t = useTranslations("ContactForm")
  const displayLabel = (label?.trim()) || t("name")

  return (
    <FormField
      control={form.control}
      name="name"
      rules={{ required: required ? t("nameRequired") : false }}
      render={({ field }) => (
        <FormItem className="space-y-2">
          <FormLabel htmlFor="name">{displayLabel}</FormLabel>
          <FormControl>
            <Input
              id="name"
              className="glass-panel"
              {...field}
            />
          </FormControl>
        </FormItem>
      )}
    />
  )
}

export default ContactNameField